import { createFileRoute } from "@tanstack/react-router";
import { drawerSearch } from "@/components/admin/shared";
import { ItemTypesPage } from "@/components/schema/ItemTypesPage";

/** Administration: item types. `?type=<id>` (or `new`) opens the editor drawer. */
export const Route = createFileRoute("/_app/admin/types")({
  validateSearch: drawerSearch("type"),
  component: ItemTypesPage,
});
